import { useCallback, useMemo } from 'react';
import { RackingArea } from '@thive/fddm-types';

import { SelectInput } from '@common/components/inputs';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { areasToFlatCollection, isRackingArea } from '@/modules/floorplanDesign/helpers';
import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';

const STACKING_OPTIONS: { label: string; value: RackingArea['stacking'] }[] = [
  { label: 'Top', value: 'HORIZONTAL_TOP' },
  { label: 'Middle', value: 'HORIZONTAL_MIDDLE' },
  { label: 'Bottom', value: 'HORIZONTAL_BOTTOM' },
];

function Alignment() {
  const selectedAreas = useReadSelectedAreas();
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const stacking = useMemo(() => {
    const areas = areasToFlatCollection(selectedAreas);
    if (areas.length !== 1) return;
    const area = areas[0];
    if (!isRackingArea(area)) return;

    const { stacking } = area;
    return stacking;
  }, [selectedAreas]);

  const onChange = useCallback(
    (newValue: RackingArea['stacking']) => {
      const areas = areasToFlatCollection(selectedAreas);
      if (areas.length !== 1) return;
      const area = areas[0];
      if (!isRackingArea(area)) return;
      fddmSvc.setPreference('rackingArea.stacking', newValue);
      fddmSvc.updateArea({
        ...area,
        stacking: newValue,
      });
    },
    [fddmSvc, selectedAreas],
  );

  if (stacking === undefined) return null;

  return <SelectInput options={STACKING_OPTIONS} onChange={onChange} value={stacking} />;
}

export default Alignment;
